import { makeActionCreator } from '../../../utilities'
import { PatientImmunizationsConstants } from './patientImmunizations.constants'

export const saveImmunization = makeActionCreator(PatientImmunizationsConstants.SAVE_IMMUNIZATION)
export const setYear = makeActionCreator(PatientImmunizationsConstants.SET_YEAR, 'year', 'key')
export const setOtherName = makeActionCreator(PatientImmunizationsConstants.SET_OTHERNAME, 'otherName')
export const setUpToDate = makeActionCreator(PatientImmunizationsConstants.SET_UPTODATE, 'upToDate')
export const setPatientImmunizationType = makeActionCreator(
  PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATION_TYPE,
  'immunizationType',
  'key'
)
export const setImmunizations = makeActionCreator(PatientImmunizationsConstants.SET_IMMUNIZATIONS, 'immunizations')
export const setPatientImmunizations = makeActionCreator(
  PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS,
  'patientImmunizations'
)
export const setPatientImmunizationStatus = makeActionCreator(
  PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_STATUS,
  'immunizationStatus',
  'immunizationStatusDate'
)
export const setPatientImmunizationIncompleteReason = makeActionCreator(
  PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON,
  'immunizationIncompleteReason'
)
export const addPatientImmunization = makeActionCreator(PatientImmunizationsConstants.ADD_PATIENT_IMMUNIZATION_CARD)
export const resetPatientImmunizations = makeActionCreator(PatientImmunizationsConstants.RESET_PATIENT_IMMUNIZATIONS)
export const removePatientImmunization = makeActionCreator(
  PatientImmunizationsConstants.REMOVE_PATIENT_IMMUNIZATION,
  'key'
)
